"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSubmitResponseMapper = void 0;
var OrderSubmitResponseMapper = /** @class */ (function () {
    function OrderSubmitResponseMapper(data) {
        this.localData = data;
    }
    OrderSubmitResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return OrderSubmitResponseMapper;
}());
exports.OrderSubmitResponseMapper = OrderSubmitResponseMapper;
//# sourceMappingURL=OrderSubmitResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/OrderSubmitResponseMapper.js
// module id = 2075
// module chunks = 8